import AdoptionRate from "./AdoptionRate";
import News from "./News";
import PasswordSecurity from "./PasswordSecurity";
import UserLoginByTime from "./UserLoginByTime";
import UsersBlocked from "./UsersBlocked";

const dashboardComponents = {
  AdoptionRate,
  News,
  PasswordSecurity,
  UserLoginByTime,
  UsersBlocked
}

export default dashboardComponents